<template>
	<v-app id="setup-password-confirmed">
		<v-container fluid fill-height>
			<v-layout align-center justify-center>
				<div class="text-md-center">
					<h1>Dziękujemy</h1>
					<h2 class="my-3 headline ">Hasło zostało pomyślnie ustawione</h2>
					<div>
						<v-btn color="primary" to="/home">Powrót</v-btn>
					</div>
				</div>
			</v-layout>
		</v-container>
	</v-app>
</template>

<script>
	export default {
		name: "SetupPasswordConfirmationView",

		data() {
			return {
				email: "",
			};
		},


		beforeMount() {
			this.email = this.$route.query.email;
		},
	};
</script>

<style scoped>

</style>
